module.exports = __webpack_public_path__ + "img/salonrandevu-gorsel-700x450.3a644a68.png";